import { default as doAskInfoModel } from './askInfoModel';
import { default as doReleaseModel } from './releaseModel';
import { default as doAnswerModel } from './answerModel';

const actions = {
  ...doAskInfoModel.actions,
  ...doReleaseModel.actions,
  ...doAnswerModel.actions
};
export default actions;
